module.exports = __webpack_public_path__ + "static/media/ring.922fa049.svg";